<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-light bg-light ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo-g.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-primary btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section
			class="login-container height-auto bg-grey200 flex-shrink-0 container-fluid"
		>
			<form class="form-signin card mt-4 bg-light">
				<h5 class="text-center mb-3">Verify Email</h5>
				<div class="form-group text-center ">
					<img src="../../assets/img/mail.svg" width="40" alt="" />
				</div>
				<div class="form-group">
					<p class="text-green text-center">
						To verify your email address, enter the code we sent you via email
						to continue
					</p>
				</div>
				<div class="form-group">
					<div class="input-group verify">
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
						/>
						<input
							class="form-control"
							v-on:keyup="$event.target.nextElementSibling.focus()"
							maxlength="1"
						/>
						<input class="form-control" maxlength="1" />
					</div>
				</div>
				<button
					class="btn btn-outline-light btn-block text-uppercase mt-3"
					v-on:click.stop.prevent="verifyEmail"
				>
					VERIFY
				</button>
				<small class="text-center pt-3"
					>Didn’t receive a verification code?
					<a href="">Request a new one</a></small
				>
				<small class="text-center pt-3">{{ textfloating }}</small>
			</form>
			<p class="text-center pt-4">Download App</p>
			<p class="text-center ">
				<img
					src="../../assets/img/google-play.png"
					alt=""
					class="cursor-pointer"
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>

		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}
</style>

<script>
export default {
	name: "emailverify",
	components: {},
	created() {
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		this.token = this.$route.query.token;
		this.email = this.$route.query.uid;
		this.$store.commit("setloaderText", {
			show: true,
			text: "Verifing your email please wait and don't refresh The page",
		});
		// this.verifyEmail();
	},
	methods: {
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		goToPackage() {
			this.$router.push("/packages");
		},
		verifyEmail() {
			this.$store.commit("setLoader", false);
			var self = this;
			this.$store
				.dispatch("verifyEMAIL", {
					username: this.email,
					token: this.token,
				})
				.then((res) => {
					self.textfloating = res.message;
					self.$store.commit("setLoader", false);
					setTimeout(function() {
						self.$router.push({ name: "login" });
					}, 5000);
				})
				.catch((err) => {
					self.textfloating = err.response.data.error.message;
				});
		},
	},

	data() {
		return {
			token: "",
			email: "",
			phone: "",
			textfloating: "",
			successMsg: false,
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
